import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CancelPage() {
  const navigate = useNavigate();

  return (
    <div style={{height:'80vh', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}} className="absolute inset-0 flex flex-col items-center justify-center bg-red-50 text-red-900 text-center px-4">
      <h1 className="text-4xl font-bold mb-4">Payment Canceled</h1>
      <p className="text-lg mb-6">You canceled the checkout. You can try again anytime.</p>
      <Button
        style={{maxWidth:'20vw'}}
        onClick={() => navigate("/pricing")}
        className="bg-black text-white hover:bg-gray-900"
      >
        Return To Pricing
      </Button>
    </div>
  );
}
